var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item_image"},[_c('product-zoomer',{attrs:{"base-images":_vm.images,"base-zoomer-options":_vm.zoomerOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }